import ControlsBar from './ControlsBar';

export default ControlsBar;
